<footer>
  <div>
    <a href="https://scribouilli.org/" target="_blank">
      Site explicatif Scribouilli
    </a>
  </div>
</footer>
